/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import {ExdsTheme} from "@exds/theme";
import {ExdsButton} from "@exds/core";
import { TuxModal } from '@tuxedo/react-component-library';
import React from "react";


export default function InfoAboutPermissionModal({isPermissionInfoModalOpen, setIsPermissionInfoModalOpen}) {
  return (
    <TuxModal
      className="modal-container"
      type='popup'
      title="Smart Log On Permissions"
      open={isPermissionInfoModalOpen}
      onCloseModal={() => setIsPermissionInfoModalOpen(false)}
      body={
        <ExdsTheme>
          <p>
            The Smart Log On mobile app requires the following permissions in order to function correctly
            and grant appropriate access:
            </p>
          <p>
            <strong>Camera access:</strong> Allows the app to scan QR codes via your phone's camera and pair your device.
          </p>
          <p>
            <strong>Push notifications:</strong> Allows the app to prompt you for your biometrics for access
            and to notify you of other important access related information.
          </p>
        </ExdsTheme>
      }
      footer={
        <ExdsTheme>
          <ExdsButton
            data-testid="close-modal-button"
            text="Close"
            variant="tertiary"
            className="modal-close-button"
            onClick={() => setIsPermissionInfoModalOpen(false)}
          />
        </ExdsTheme>
      }
    />
  );
}
